<div class="container section pt-5">
  <div class="row-12">
    <div class="col p-0">
      <div class="col">
        <div class="card p-2 bg-light">
          <nav class="navbar navbar-light bg-light" aria-label="Main Navigation">
            <div class="container">
              <a class="navbar-brand">{{number}} Connects </a>
              <form class="d-flex">
                <input
                  class="form-control me-2"
                  type="search"
                  placeholder="Search"
                  aria-label="Search"
                  (keyup)="applyFilter($event)"
                  #input
                />
              </form>
            </div>
          </nav>
        </div>
        <div class="card border p-4">
          <div class="mat-elevation-z8 overflow">
            <table mat-table [dataSource]="dataSource" matSort>
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                <td mat-cell *matCellDef="let row">
                  {{ row.firstName }} {{ row.middleName }} {{ row.lastName }}
                </td>
              </ng-container>

              <ng-container matColumnDef="street">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Destination
                </th>
                <td mat-cell *matCellDef="let row">
                  {{ row.street }} {{ row.city }} {{ row.state }}
                  {{ row.country }}
                </td>
              </ng-container>

              <ng-container matColumnDef="country">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Country
                </th>
                <td mat-cell *matCellDef="let row">{{ row.country }}</td>
              </ng-container>

              <ng-container matColumnDef="check">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Check In
                </th>
                <td mat-cell *matCellDef="let row"></td>
              </ng-container>

              <ng-container matColumnDef="fromCity">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Ghana Address
                </th>
                <td mat-cell *matCellDef="let row">{{ row.fromCity }}</td>
              </ng-container>

              <ng-container matColumnDef="phone">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Phone</th>
                <td mat-cell *matCellDef="let row">{{ row.phone }}</td>
              </ng-container>
              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                <td mat-cell *matCellDef="let row">{{ row.email }}</td>
              </ng-container>

              <ng-container matColumnDef="region">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Region
                </th>
                <td mat-cell *matCellDef="let row">{{ row.region }}</td>
              </ng-container>

              <ng-container matColumnDef="reason">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Reason
                </th>
                <td mat-cell *matCellDef="let row">{{ row.reason }}</td>
              </ng-container>

              <ng-container matColumnDef="denominations">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Denomination
                </th>
                <td mat-cell *matCellDef="let row">{{ row.denominations }}</td>
              </ng-container>

              <ng-container matColumnDef="churchName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Church Name
                </th>
                <td mat-cell *matCellDef="let row">{{ row.churchName }}</td>
              </ng-container>

              <ng-container matColumnDef="itinerary">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Itinerary
                </th>
                <td mat-cell *matCellDef="let row">
                  <button
                    type="button"
                    class="btn btn-primary"
                    (click)="openModal('itinerary')"
                    (click)="getConnects(row)"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="60"
                      height="20"
                      viewBox="0 0 576 512"
                    >
                      <path
                        d="M482.3 192c34.2 0 93.7 29 93.7 64c0 36-59.5 64-93.7 64l-116.6 0L265.2 495.9c-5.7 10-16.3 16.1-27.8 16.1l-56.2 0c-10.6 0-18.3-10.2-15.4-20.4l49-171.6L112 320 68.8 377.6c-3 4-7.8 6.4-12.8 6.4l-42 0c-7.8 0-14-6.3-14-14c0-1.3 .2-2.6 .5-3.9L32 256 .5 145.9c-.4-1.3-.5-2.6-.5-3.9c0-7.8 6.3-14 14-14l42 0c5 0 9.8 2.4 12.8 6.4L112 192l102.9 0-49-171.6C162.9 10.2 170.6 0 181.2 0l56.2 0c11.5 0 22.1 6.2 27.8 16.1L365.7 192l116.6 0z"
                      />
                    </svg>
                  </button>
                </td>
              </ng-container>

              <ng-container matColumnDef="admincheckindetails">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Admin Details
                </th>
                <td mat-cell *matCellDef="let row">
                  @if (row.connectStatus) {
                  <button
                    type="button"
                    class="btn btn-warning"
                    (click)="openModal('adminCheckDetails')"
                    (click)="getConnects(row)"
                  >
                    <span>Info</span>
                  </button>
                  } @else {
                  <button
                    type="button"
                    class="btn btn-dark"
                    disabled
                    (click)="openModal('adminCheckDetails')"
                    (click)="getConnects(row)"
                  >
                    <span>Not Ready </span>
                  </button>
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="checkin">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Complete Status
                </th>
                <td mat-cell *matCellDef="let row">
                  @if (row.connectStatus) {
                  <button
                    type="button"
                    class="btn btn-success"
                    (click)="openModal('checkin')"
                    (click)="getConnects(row)"
                  >
                    <span>Done</span>
                  </button>
                  } @else {
                  <button
                    type="button"
                    class="btn btn-danger"
                    (click)="openModal('checkin')"
                    (click)="getConnects(row)"
                  >
                    <span>Not Yet</span>
                  </button>
                  }
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">
                  No data matching the filter "{{ input.value }}"
                </td>
              </tr>
            </table>
            
            <nav aria-label="Page navigation example">
              <ul class="pagination justify-content-end">
                <li class="page-item " [ngClass]="{'disabled': listOption.page === 1}">
                  <a class="page-link" (click)="previous()" (keydown)="previous()" tabindex="-1" >Previous</a>
                </li>
                @for (item of pageNumbers; track $index) {
                <li class="page-item" [ngClass]="{'active': item === listOption.page}">
                  <a class="page-link" (click)="getPage(item)" (keydown)="getPage(item)" tabindex="0">{{item}}</a> </li>
                }
                <li class="page-item" [ngClass]="{'disabled': listOption.page === totalPages}">
                  <a class="page-link" (click)="next()" (keyup.enter)="next()" tabindex="0">Next</a>
                </li>
              </ul>
            </nav>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</div>
<div class="mobile">
  <app-mobile-admin [connectsDataSource]="connectsDataSource" #mobile></app-mobile-admin>
</div>

<div #itinerary class="modal fade" tabindex="-1" aria-labelledby="itinerary">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="itinerary">Itinerary</h5>
        <button
          type="button"
          class="btn-close"
          (click)="closeModal('itinerary')"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">Departure Date</th>
              <th scope="col">Departure Time</th>
              <th scope="col">Arrival Date</th>
              <th scope="col">Arrival Time</th>
              <th scope="col">Flight</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ connect.departureDate }}</td>
              <td>{{ connect.departureTime }}</td>
              <td>{{ connect.arrivalDate }}</td>
              <td>{{ connect.arrivalTime }}</td>
              <td>{{ connect.flightName }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeModal('itinerary')"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<div
  #checkin
  class="modal fade"
  tabindex="-1"
  aria-labelledby="modalLabelCheckin"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="modalLabelCheckin">Admin Check In</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <form #leadershipForm="ngForm">
          <div class="mb-3">
            <label for="mobile" class="form-label"> Admin Name</label>
            <input
              class="form-control"
              type="text"
              id="adminFullName"
              name="adminFullName"
              [(ngModel)]="connect.adminFullName"
              #adminFullName="ngModel"
            />
          </div>
          <div class="mb-3">
            <label for="mobile" class="form-label">Admin Email</label>
            <input
              class="form-control"
              type="email"
              id="adminEmail"
              name="adminEmail"
              [(ngModel)]="connect.adminEmail"
              #adminEmail="ngModel"
            />
          </div>

          <div class="mb-3">
            <label for="mobile" class="form-label">Check In Date</label>
            <input
              class="form-control"
              type="date"
              id="title"
              name="title"
              [(ngModel)]="connect.checkInDate"
              #checkInDate="ngModel"
            />
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeModal('checkin')"
        >
          Close
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="closeModal('checkin')"
          [disabled]="!leadershipForm.valid"
          (click)="onSubmit()"
        >
          Check Complete
        </button>
      </div>
    </div>
  </div>
</div>

<div
  #adminCheckDetails
  class="modal fade"
  tabindex="-1"
  aria-labelledby="modalLabelAdminCheckDetails"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="modalLabelAdminCheckDetails">
          Admin Check Details
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">Admin Name</th>
              <th scope="col">Admin Email</th>
              <th scope="col">Connect Status</th>
              <th scope="col">Connect Date</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ connect.adminFullName }}</td>
              <td>{{ connect.adminEmail }}</td>
              <td>{{ connect.connectStatus }}</td>
              <td>{{ connect.checkInDate }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeModal('adminCheckDetails')"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>
